// import { useEffect, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { openErrorNotification } from "../utils/toast";

// const AutoLogout = ({ timeout }) => {
//   const [isActive, setIsActive] = useState(true);
//   const timerRef = useRef(null);
//   const navigate = useNavigate();

//   const isLoggedIn = sessionStorage.getItem("userData");

//   const resetTimer = () => {
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }
//     timerRef.current = setTimeout(() => {
//       setIsActive(false);
//     }, timeout);
//   };

//   useEffect(() => {
//     if (!isActive && isLoggedIn) {
//       sessionStorage.removeItem("userData");
//       sessionStorage.removeItem("customerInfo");
//       openErrorNotification("Your login session is expired.");
//       navigate("/");
//     }
//   }, [isActive]);

//   useEffect(() => {
//     const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

//     const handleActivity = () => {
//       setIsActive(true);
//       resetTimer();
//     };

//     events.forEach((event) => window.addEventListener(event, handleActivity));

//     resetTimer();

//     return () => {
//       events.forEach((event) =>
//         window.removeEventListener(event, handleActivity)
//       );
//       if (timerRef.current) clearTimeout(timerRef.current);
//     };
//   }, []);

//   return null;
// };

// export default AutoLogout;

import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { openErrorNotification } from "../utils/toast";
import axios from "axios"; // Make sure axios is imported

const AutoLogout = ({ timeout }) => {
  const [isActive, setIsActive] = useState(true);
  const timerRef = useRef(null);
  const navigate = useNavigate();

  const isLoggedIn = sessionStorage.getItem("userData");

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setIsActive(false);
    }, timeout);
  };

  useEffect(() => {
    if (!isActive && isLoggedIn) {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("customerInfo");
      sessionStorage.removeItem("engageData");
      openErrorNotification("Your login session is expired.");
      navigate("/");
    }
  }, [isActive]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const handleActivity = () => {
      setIsActive(true);
      resetTimer();
    };

    events.forEach((event) => window.addEventListener(event, handleActivity));

    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  useEffect(() => {
    // Add Axios response interceptor for handling 403 errors
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response, // Return the response if everything is fine
      (error) => {
        // Check for 403 error and handle the session expiration
        if (error.response && error.response.status === 403) {
          sessionStorage.removeItem("userData");
          sessionStorage.removeItem("customerInfo");
          sessionStorage.removeItem("engageData");
          openErrorNotification(
            "Your session has expired. Please log in again."
          );
          navigate("/"); // Redirect to login page
        }
        return Promise.reject(error); // Reject the error to continue the normal flow
      }
    );

    // Cleanup the interceptor on component unmount
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);

  return null;
};

export default AutoLogout;
